<template lang="pug">
.section
  .section-header
    h1 {{ $t("ui.profile_setting") }}
  .section-body
    .row
      .col-12
        .card.mb-0
          .card-header
            .row
              .form-group.col-12.mb-1
                SubmitButton(
                  :loading="loading"
                  icon="fa fa-retweet"
                  :text="$t('ui.refresh')"
                  type="button"
                  @click="refreshList()"
                  variant="primary"
                  size="sm"
                )
          .card-body
            .row
              .col-md-6
                .clusterize-scroll.table-responsive
                  table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
                    thead.thead-light
                      tr
                        th(width="30%")
                          span {{ $tc('ui.key', 1) }}
                        th.text-center(width="15%")
                          span {{ $tc('ui.value', 1) }}
                        th(width="20%")
                          span {{ $tc('ui.remark', 1) }}
                        th(width="20%")
                          span {{ $tc('ui.remark', 1) }}2
                        th.text-center(width="10%" v-if="isAdminMaster && isEditAccess")
                          span {{ $t("ui.action") }}
                    tbody.clusterize-content
                      tr(v-if="settingList.length == 0")
                        td(colspan="5").text-center
                          span {{ $t('message.no_data_available') }}
                      tr(v-for="(item, index) in settingList")
                        td
                          template(v-if="item.setting_key == 'min_deposit'")
                            span(:title='$t("ui.minimum_deposit")') {{ $t("ui.minimum_deposit") }}
                          template(v-else-if="item.setting_key == 'min_withdrawal'")
                            span(:title='$t("ui.minimum_withdrawal")') {{ $t("ui.minimum_withdrawal") }}
                          template(v-else-if="item.setting_key == 'max_withdrawal'")
                            span(:title='$t("ui.maximum_withdrawal")') {{ $t("ui.maximum_withdrawal") }}
                          template(v-else)
                            span(:title='$t("ui." + item.setting_key, { currency: getCurrencyCode })') {{ $t("ui." + item.setting_key, { currency: getCurrencyCode }) }}
                        td.text-center
                          template(v-if="['affiliate','maintenance','free_game','tac_bank','tac_login','tac_signup','tac_signup_aff', 'crypto_withdrawal', 'ewallet_withdrawal'].includes(item.setting_key)")
                            template(v-if="item.setting_value")
                              span.font-weight-bold.badge.badge-success(:title='$t("ui." + item.setting_value)') {{ $t('ui.on') }}
                            template(v-else)
                              span.font-weight-bold.badge.badge-danger(:title='$t("ui." + item.setting_value)') {{ $t('ui.off') }}
                          template(v-else)
                            span.font-weight-bold(:title="$helpers.isNumeric(item.setting_value) == true ? $n(item.setting_value, 'integer') : item.setting_value") {{ $helpers.isNumeric(item.setting_value) == true ? $n(item.setting_value, 'integer') : item.setting_value }}
                        td
                          span(v-if="item.setting_key != 'maintenance'" :title='item.remark') {{ item.remark }}
                          span(v-else :title="item.remark ? $moment(item.remark).format('YYYY-MM-DD, HH:mm:ss') : item.remark") {{ item.remark ? $moment(item.remark).format('YYYY-MM-DD, HH:mm:ss') : item.remark }}
                        td
                          span(v-if="item.setting_key != 'maintenance'" :title='item.remark2') {{ item.remark2 }}
                          span(v-else :title="item.remark2 ? $moment(item.remark2).format('YYYY-MM-DD, HH:mm:ss') : item.remark2") {{ item.remark2 ? $moment(item.remark2).format('YYYY-MM-DD, HH:mm:ss') : item.remark2 }}
                        td.text-center(v-if="isAdminMaster && isEditAccess")
                          span
                            a.fa.fa-edit.btn.btn-ssm.btn-icon.btn-primary(href="javascript:void(0)" @click="onUpdate(item)" :title="$t('ui.update')")
                          span.ml-1(v-if="item.setting_key == 'maintenance' && item.setting_value > 0")
                            a.fa.fa-eraser.btn.btn-ssm.btn-icon.btn-danger(href="javascript:void(0)" @click="onClear(item)" :title="$t('ui.clear')")

              .col-md-6
                .clusterize-scroll.table-responsive
                  table.table.table-sm.table-bordered.table-striped.table-hover
                    thead.thead-light
                      tr
                        th(width="20%")
                          span {{ $tc('ui.key', 1) }}
                        th(width="20%")
                          span {{ $tc('ui.value', 1) }}
                        th(width="20%")
                          span {{ $tc('ui.remark', 1) }}
                        th.text-center(width="10%" v-if="isAdminMaster && isEditAccess")
                          span {{ $t("ui.action") }}
                    tbody.clusterize-content
                      tr(v-if="settingList2.length == 0")
                        td(colspan="4").text-center
                          span {{ $t('message.no_data_available') }}
                      tr(v-for="(item, index) in settingList2")
                        td
                          span(:title='$t("ui." + item.setting_key)') {{ $t("ui." + item.setting_key) }}
                        td
                          span(:title='item.setting_value') {{ item.setting_key == 'access_control' ? $t("ui.auto_" + item.setting_value.toLowerCase()) : item.setting_value }}
                        td
                          span(:title='item.remark') {{ item.remark }}
                        td.text-center
                          template(v-if="item.setting_key == 'access_control' || item.setting_key == 'tp_site'")
                            span(v-if="isAdminMaster && isEditAccess")
                              a.fa.fa-edit.btn.btn-ssm.btn-icon.btn-primary(href="javascript:void(0)" @click="onUpdate2(item)" :title="$t('ui.update')")

    updateprofilesetting(ref="updateprofilesetting" :item="editSelectedSetting" :exchangePointRate="exchangePointRate" @clicked="afterUpdate" @failed="handleFailed")
    updateprofilesetting2(ref="updateprofilesetting2" :item="editSelectedSetting2" @clicked="afterUpdate2" @failed="handleFailed")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import { required, minLength, maxLength, alphaNum, integer, email, helpers, decimal, requiredIf } from "vuelidate/lib/validators";
import ValidateResult from "@/library/ValidateResult";
import updateprofilesetting from "@/components/system/updateProfileSetting.vue";
import updateprofilesetting2 from "@/components/system/updateProfileSetting2.vue";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    ValidateResult,
    updateprofilesetting,
    updateprofilesetting2
  },
  data: () => ({
    loading: false,
    feedback: {
      success: true,
      status: ""
    },
    settingList: [],
    settingList2: [],
    editSelectedSetting: null,
    editSelectedSetting2: null,
    exchangePointRate: null
  }),
  computed: {
    isAdmin() {
      return this.$store.getters.accountType === 5;
    },
    isAdminMaster() {
      return [3,5].includes(this.$store.getters.accountType);
    },
    isEditAccess() {
      return this.$helpers.showActionButton("e_profilesetting");
    },
    getCurrencyCode() {
      return this.$store.getters.currencyCode;
    }
  },
  mounted: function() {
    this.refreshList();
  },
  methods: {
    refreshList() {
      this.getGlobalSettingList();
      this.getGlobalSettingList2();
    },
    onClear: function(item) {
      this.$helpers
        .alert({
          title: this.$t("ui.status"),
          text: this.$t("message.clear_profile_setting_maintenance_confirm"),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmClear(item);
          }
        });
    },
    confirmClear: function(item, isUp) {
      let url = config.globalSettingUpdateUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        setting_key: item.setting_key,
        setting_value: 0,
        remark: null,
        remark2: null
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.afterUpdate();
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    onUpdate(e) {
      this.editSelectedSetting = e;
      this.exchangePointRate = null
      if(e.setting_key == 'free_coin_min_withdrawal') {
        for(var i = 0; i < this.settingList.length; i++) {
          if(this.settingList[i].setting_key == 'free_coin_per_unit') {
            this.exchangePointRate = this.settingList[i].setting_value
          }
        }
      }

      this.$refs.updateprofilesetting.$refs.updateProfileSetting.show();
    },
    afterUpdate: function() {
      this.getGlobalSettingList();
      this.$helpers.showDialog(this.$t("ui.combine.update_profile_setting"), this.$t("message.success"), "success");
    },
    onUpdate2(e) {
      this.editSelectedSetting2 = e;
      this.$refs.updateprofilesetting2.$refs.updateProfileSetting2.show();
    },
    afterUpdate2: function() {
      this.getGlobalSettingList2();
      this.$helpers.showDialog(this.$t("ui.combine.update_profile_setting"), this.$t("message.success"), "success");
    },
    getGlobalSettingList: function(item) {
      let url = config.globalSettingListUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.settingList = response.data.dt;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getGlobalSettingList2: function(item) {
      let url = config.globalSettingList2Url();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.settingList2 = response.data.dt;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>